export default __webpack_public_path__ + "static/media/background.0eac75f4.jpg";